/**
 * Flattens a markdown body to the one line of prose a row can show.
 *
 * The editor deliberately keeps `##` and `**` visible in the text, because
 * that is the document. A 12px preview line is not the document — leading
 * `## ` there is noise standing where the first real words should be.
 */
export function previewText(body: string, limit = 120): string {
  const flat = body
    // Fenced code blocks say nothing useful at preview length.
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/^\s*!\[[^\]]*]\([^)]*\)\s*$/gm, ' ')
    .split('\n')
    .map(stripLine)
    .filter((line) => line.length > 0)
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();

  return flat.length > limit ? `${flat.slice(0, limit).trimEnd()}…` : flat;
}

function stripLine(line: string): string {
  return line
    .replace(/^\s{0,3}#{1,6}\s+/, '') //  ## Heading
    .replace(/^\s{0,3}>\s?/, '') //       > quote
    .replace(/^\s*[-*+]\s+\[[ xX]]\s+/, '') // - [ ] task
    .replace(/^\s*[-*+]\s+/, '') //       - bullet
    .replace(/^\s*\d+\.\s+/, '') //       1. ordered
    .replace(/^\s{0,3}([-*_])\s*(\1\s*){2,}$/, '') // --- rule
    .replace(/!\[([^\]]*)]\([^)]*\)/g, '$1') // image → alt text
    .replace(/\[([^\]]+)]\([^)]*\)/g, '$1') // link → label
    .replace(/(\*\*|__)(.*?)\1/g, '$2') // bold
    .replace(/(\*|_)(.*?)\1/g, '$2') //   italic
    .replace(/~~(.*?)~~/g, '$1') //       strikethrough
    .replace(/`([^`]*)`/g, '$1') //       inline code
    .trim();
}
